
export default {
    setLanguageCurrent({ commit }, payload) {
        commit('SET_LANGUAGE_CURRENT', payload);
    },
    setChecked({ commit }, payload) {
        commit('SET_CHECKED', payload);
    },
    setUser({ commit }, payload) {
        commit('SET_USER', payload);
    },
    setNewOrder({ commit }, payload) {
        commit('SET_newOrder', payload);
    },
    openModal({ commit }, payload) {
        commit('OPEN_MODAL', payload);
    },
    selectValue({ commit }, payload) {
        commit('SET_VALUE', payload);
    },
    setLastUpdate({ commit }, payload) {
        commit('SET_LAST_UPDATE', payload);
    },
    setFeatures({ commit }, payload) {
        commit('SET_FEATURES', payload);
    },
    setAudio({ commit }, payload) {
        commit('SET_AUDIO', payload);
    },
    setTicket({ commit }, payload) {
        commit('SET_TICKET', payload);
    },
    setLanguages({ commit }, payload) {
        commit('SET_LANGUAGES', payload);
    },
    setStats({ commit }, payload) {
        commit('SET_STATS', payload);
    },
    setLocalizations({ commit }, payload) {
        commit('SET_LOCALIZATIONS', payload);
    },
    setText({ commit }, payload) {
        commit('SET_TEXT', payload);
    },
    setLanguage({ commit }, payload) {
        commit('SET_LANGUAGE', payload);
    },
    setLocations({ commit }, payload) {
        commit('SET_LOCATION', payload);
    },
    setMessage({ commit }, payload) {
        commit('SET_MESSAGE', payload);
    },
    setRoot({ commit }, payload) {
        commit('SET_ROOT', payload);
    },
    setRoles({ commit }, payload) {
        commit('SET_ROLE', payload);
    },
    setRoutes({ commit }, payload) {
        commit('SET_ROUTES', payload);
    },
    setBusiness({ commit }, payload) {
        commit('SET_BUSINESS', payload);
    },
    setSchedule({ commit }, payload) {
        commit('SET_SCHEDULE', payload);
    },
    setPost({ commit }, payload) {
        commit('SET_POST', payload);
    },
    setShop({ commit }, payload) {
        commit('SET_SHOP', payload);
    },
    setHost({ commit }, payload) {
        commit('SET_HOST', payload);
    }
}
